import React from 'react';
import {Col} from "antd";

import { CardPreview, CardPreviewRow } from "components/card";
import { encode } from "utils";


const CardListCollectionPreview  = (props) => {

    const {
        node : {
            id,
            collection_id,
            post_id,
            post
        },
        prefixPath,
        view,
        showAuthor
    } = props;

    const slug = encode.toSlug([id, collection_id, post_id]).replace(/[=]/g, '');

    if( view === 'row'){
        return (
            <Col span={ 24 } className="card-preview-row-holder">
                <CardPreviewRow
                    post={ post }
                    showAuthor={ showAuthor }
                    fullPath={ `${prefixPath}/${slug}` }
                />
            </Col>
        );
    }

    return (
        <Col span={8} className="card-preview-holder">
            <CardPreview
                post={ post }
                fullPath={ `${prefixPath}/${slug}` }
                counters
            />
        </Col>
    );
};


export default CardListCollectionPreview;